let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6QJim")).then(() => parcelRequire('5lIsC'));